import { render, staticRenderFns } from "./WhiteChip.vue?vue&type=template&id=9f4bc36a&scoped=true"
import script from "./WhiteChip.vue?vue&type=script&lang=ts"
export * from "./WhiteChip.vue?vue&type=script&lang=ts"
import style0 from "./WhiteChip.vue?vue&type=style&index=0&id=9f4bc36a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4bc36a",
  null
  
)

export default component.exports